// 公共
export const SupplyRouterName = {
  /** 售后单 */
  AfterSales: '/supply/after_sales/list',
  /** 新增售后单 */
  AfterSalesCreate: '/supply/after_sales/create',
  /** 售后单详情 */
  AfterSalesDetail: '/supply/after_sales/detail',
  /**
   * 售后单编辑
   */
  AfterSalesEdit: '/supply/after_sales/edit',
  /**
   * 采购单详情
   */
  PurchaseOrderDetail: '/supply/purchase_order/detail',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  StatementDetail: '/supply/bill/reconciliation/detail',
  /** 折扣定价单 */
  DiscountPriceList: '/supply/inquiry_quotation/discount_price/list',
  /** 折扣定价单详情 */
  DiscountPricesDetail: '/supply/inquiry_quotation/discount_price/detail',

  /** 商品行情价 */
  MarketPriceList: '/supply/inquiry_quotation/market_price/list',
  /** 商品行情价详情 */
  MarketPricesDetail: '/supply/inquiry_quotation/market_price/detail',
  /** 商品行情价编辑 */
  MarketPricesEdit: '/supply/inquiry_quotation/market_price/edit',
  /** 商品行情价创建 */
  MarketPricesCreate: '/supply/inquiry_quotation/market_price/create',

  /** 折扣定价单公示列表 */
  DiscountPricesPublic: '/supply/report/discount_price_public/list',
  /** 折扣定价单公示结果 */
  DiscountPricesResult: '/supply/report/discount_price_public/result',

  /** 司机绩效 */
  DriverPerformanceList: '/supply/driver_performance/list',

  /** 配送任务 */
  ManageDeliveryTaskList: '/supply/delivery_task/list',

  /** 合同详情 */
  PurchaserContractDetail: '/supply/report/discount_price_public/contract_detail',
};
